export default {
  app: {
    privacy: {
      policy: 'Գաղտնիության քաղաքականություն',
      expansive: 'Օգտագործելով Expansive-ը, դուք համաձայնում եք Expansive {action}-ին',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Նիստը ավարտվել է',
    sessionExpiredDescription:
      'Ձեր նստաշրջանը ավարտվել է։ Խնդրում ենք կրկին մուտք գործել՝ հավելվածը շարունակելու համար։',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Ընտրեք լեզուն',
      chooseLanguageDescription:
        'Ընտրեք հավելվածի համար նախընտրելի լեզուն։ Սա կփոխի միջերեսի և բովանդակության լեզուն։',
    },
    userSelection: {
      cancel: 'Չեղարկել',
      createNewUser: 'Նրանց անունը ցուցակում չէ',
      newUser: 'Նոր օգտվող',
      selectAnExistingUser: 'Ընտրեք առկա օգտվողին',
      selectUserHint: 'Ընտրեք առկա օգտվողին կամ ստեղծեք նոր՝ շարունակելու համար։',
      startTypingToSearch: 'Սկսեք մուտքագրել...',
    },
    verification: {
      codeVerification: {
        continue: 'Շարունակել',
        header: 'Մուտքագրեք տարածքի մուտքի կոդը',
        invalidCode: 'Անվավեր կոդ, փորձեք կրկին։',
      },
      geoVerification: {
        continueWithoutVerifying: 'Շարունակել առանց տեղադրությունը ստուգելու',
        enterSiteAccessCode: 'Մուտքագրեք տարածքի մուտքի կոդը',
        locationNotEnabledOrAvailable: 'Ինչու՞ եմ ես սա տեսնում:',
        notAvailable: {
          description: 'GPS տեղադրությունը չի աջակցվում այս սարքում:',
          header: 'Տեղադրությունը չի աջակցվում',
        },
        notEnabled: {
          description: 'Տեղադրության ծառայությունները միացված չեն կամ թույլտվությունը չի տրվել:',
          header: 'Տեղադրությունը միացված չէ',
        },
        notVerified: {
          description: 'GPS-ը ցույց է տալիս, որ դուք տարածքում չեք։',
          header: 'Տեղադրությունը չստուգվեց',
        },
        tryAgain: 'Փորձեք կրկին',
        unavailable: {
          description: 'Չհաջողվեց ստուգել ձեր GPS տեղադրությունը։',
          header: 'Տեղադրությունը հասանելի չէ',
        },
        unknown: {
          description: 'Չհաջողվեց որոշել ձեր տեղադրությունը։',
          header: 'Տեղադրությունը անհայտ է',
        },
        verified: {
          description: 'GPS-ը ցույց է տալիս, որ դուք տարածքում եք։',
          header: 'Տեղադրությունը ստուգված է',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Անհասանելի ակտիվներ',
        emptyDescription: 'Այս աշխատանքային կարգի հետ կապված ակտիվներ չկան։',
        warrantyParts: 'Պահեստամասերի երաշխիքային ժամկետը ավարտվում է',
        serialNumber: 'Սերիական համարը',
        none: '<չկա>',
      },
      updates: {
        emptyTitle: 'Թարմացումներ չկան',
        emptyDescription: 'Այս աշխատանքային կարգի համար թարմացումներ չկան։',
        unknownUser: 'Անհայտ օգտվող',
        none: 'Ոչ մեկը',
        addComment: {
          buttonLabel: 'Ավելացնել մեկնաբանություն',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Ապահովության միջոցներ',
          no: 'Ոչ',
          yes: 'Այո',
        },
      },
    },
    attachmentsList: {
      attachments: 'Կցված ֆայլեր',
      documents: 'Փաստաթղթեր',
      siteDocuments: 'Տարածքի փաստաթղթեր',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Ապահովության միջոցներ',
        induction: 'Ներածություն',
        safeToProceed: 'Անվտանգ է շարունակելու համար',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Ժամկետ',
        activeSessions: 'Ակտիվ նստաշրջաններ',
        activeSessionsDescription:
          'Դուք արդեն գրանցված եք հետևյալ աշխատանքային կարգերում։ Դուք պետք է դուրս գաք այս աշխատանքային կարգերից, նախքան նոր աշխատանքային կարգում գրանցվելը։',
        resumeSession: 'Շարունակել',
        startTime: 'Սկիզբի ժամանակը',
        unexpectedErrorTitle: 'Անսպասելի սխալ',
        unexpectedErrorMessage:
          'Անսպասելի սխալ է տեղի ունեցել ձեր նստաշրջանները ստեղծելու ժամանակ։ Խնդրում ենք փորձել կրկին ուշ։',
        engineerNotFound: 'Հետազոտողը չի գտնվել',
        engineerNotFoundDescription:
          'Հետազոտողը, ում դուք փորձում եք գրանցել, չի գտնվել համակարգում։ Խնդրում ենք կապվել ձեր ադմինիստրատորի հետ։',
      },
      verification: {
        code: {
          description:
            'Գրանցվելու համար խնդրում ենք ստանալ 4-հիշակետի կոդը տարածքի ղեկավարից կամ նշանակված անձից։',
        },
        geo: {
          continue: 'Շարունակել',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Խնդրում ենք ստանալ մուտքի ծածկագիրը կայքի մենեջերից կամ նշանակված կապից ձեր այցը ավարտելու համար։',
            checkOut: 'Դուրս գալ',
            completeBeforeLeaving: 'Խնդրում ենք լրացնել հետևյալ ձևը նախքան հեռանալը։',
            continue: 'Շարունակել',
            noResolutionSelected: 'Խնդրում ենք ընտրել լուծում՝ շարունակելու համար։',
            quoteRequired: {
              hint: 'Այցը ավարտված է, առաջարկը կհետեւի',
              label: 'Պատասխանատու է առաջարկի համար',
            },
            returnVisitRequired: {
              hint: 'Մենք կրկին վերադառնալու ենք ավարտելու համար',
              label: 'Պատասխանատու է վերադարձի այցի համար',
            },
            serviceCompleted: {
              hint: 'Չկա լրացուցիչ գործողություն պահանջվում',
              label: 'Ծառայությունը ավարտված է',
            },
            uploadCheckout: 'Բեռնեք ֆայլ, լուսանկար կամ տեսանյութ',
            visitNotes: 'Այցի նշումներ',
            workOrderResolution: 'Աշխատանքային կարգի լուծում',
            enterNotes: 'Մուտքագրեք ցանկացած նշումներ այստեղ...',
            errors: {
              timedOut: 'Ժամկետը լրացել է, գերազանցել է 30 վայրկյանը։ Խնդրում ենք փորձել կրկին։',
              closingSession: 'Սխալ փակել նստաշրջանը',
            },
          },
          success: {
            description:
              'Շնորհակալություն {site} այցելելու համար։ | {site} դեռ ունի 1 բաց աշխատանքային կարգ։ | {site} դեռ ունի {count} բաց աշխատանքային կարգեր։',
            endVisit: 'Ավարտել այցը',
            header: 'Դուք հաջողությամբ դուրս եք եկել',
            viewWorkOrders: 'Գրանցվել այլ աշխատանքային կարգում',
          },
          verification: {
            code: {
              description:
                'Դուրս գալու համար խնդրում ենք ստանալ 4-հիշակետի կոդը տարածքի ղեկավարից կամ նշանակված անձից։',
              continue: 'Շարունակել',
            },
            geo: {
              checkOut: 'Դուրս գալ',
              continue: 'Շարունակել',
            },
          },
        },
        detail: {
          assets: 'Ակտիվներ',
          call: 'Զանգահարել',
          checkOut: 'Դուրս գալ',
          closed: 'Փակված',
          details: 'Մանրամասներ',
          dueBy: 'Ժամկետ',
          manageEngineers: 'Կառավարել ինժեներները',
          notAvailable: 'Չի հասանելի',
          pointOfContact: 'Կապի անձ',
          siteAccessTimes: 'Տարածքի մուտքի ժամանակներ',
          siteAccessInstructions: 'Մուտքի հրահանգներ',
          siteAddress: 'Տարածքի հասցե',
          siteNotes: 'Տարածքի նշումներ',
          siteTelephone: 'Տարածքի հեռախոս',
          siteLocation: 'Տարածքի տեղադրություն',
          updates: 'Թարմացումներ',
          more: 'Ավելին',
          mismatchErrorTitle: 'Աշխատանքային կարգի սխալ',
          mismatchErrorMessage:
            'Դուք փորձում եք մուտք գործել աշխատանքային կարգ, որը չի համապատասխանում այն աշխատանքային կարգին, որի մեջ դուք արդեն գրանցված եք։ Խնդրում ենք ստուգել ձեր աշխատանքային կարգը և փորձել կրկին։',
          siteDocuments: 'Տարածքի փաստաթղթեր',
          validFrom: 'Վավեր է սկսած',
          validUntil: 'Վավեր է մինչև',
          documentName: 'Փաստաթղթի անուն',
          documentType: 'Փաստաթղթի տեսակ',
          attachments: 'Աշխատանքային կարգի ֆայլեր',
          download: 'Բեռնել',
          workDetails: 'Աշխատանքի մանրամասներ',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Ավելացնել օգնական ինժեներ',
            assistantEngineers: 'Օգնական ինժեներներ',
            description:
              'Անվտանգության պատճառներով, խնդրում ենք նշել տարածքում գտնվող յուրաքանչյուր ինժեների անունը։',
            editMainEngineer: 'Խմբագրել գլխավոր ինժեներին',
            errors: {
              creatingEngineer: 'Սխալ ստեղծել ինժեներ',
              creatingSession: 'Սխալ ստեղծել նստաշրջան',
            },
            header: 'Տարածքում գտնվող ինժեներները',
            mainEngineer: 'Գլխավոր ինժեներ',
            newAssistantEngineer: 'Մուտքագրեք նրանց ամբողջական անունը',
            next: 'Հաջորդ',
            removeEngineer: 'Հեռացնել ինժեները',
            selectExistingAssistantEngineer: 'Սկսեք մուտքագրել նրանց անունը',
          },
          index: {
            description:
              'Անվտանգության պատճառներով, խնդրում ենք նշել տարածքում գտնվող յուրաքանչյուր ինժեների անունը։',
            errorCreatingEngineer: 'Սխալ ստեղծել ինժեներ, խնդրում ենք փորձել կրկին։',
            header: 'Տարածքում գտնվող ինժեներները',
            hintMainEngineer: 'Մուտքագրեք գլխավոր ինժեների ամբողջական անունը',
            newMainEngineer: 'Նոր գլխավոր ինժեներ',
            next: 'Հաջորդ',
            selectExistingMainEngineer: 'Ընտրեք առկա գլխավոր ինժեներին',
            yes: 'Այո',
            no: 'Ոչ',
            mainEngineerLabel: 'Դուք գլխավոր ինժեներն եք՞',
          },
        },
        index: {
          callUsOn: 'Զանգահարեք մեզ այս հեռախոսահամարով {phoneNumber}',
          description: 'Չեք կարողանում գտնել այն, ինչ փնտրում եք՞',
          dueBy: 'Ժամկետ',
          header: 'Ընտրեք աշխատանքային կարգ',
          notAvailable: 'Չի հասանելի',
          searchWorkOrders: 'Փնտրեք աշխատանքային կարգեր...',
        },
        manageEngineers: {
          manageEngineers: 'Կառավարել ինժեներները',
          notWorking: 'Անգործուն աշխատողներ',
          pause: 'Կանգնեցնել',
          resume: 'Շարունակել',
          workingNow: 'Ակտիվ աշխատողներ',
          startTime: 'Սկիզբի ժամանակ',
          endTime: 'Ավարտի ժամանակ',
          duration: 'Տևողություն',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Մեկնաբանություն',
            feedbackDescription:
              'Խնդրում ենք մեկնաբանություն թողնել աշխատանքային կարգի վերաբերյալ, որպեսզի մենք կարողանանք բարելավել մեր ծառայությունները։',
            feedbackLabel: 'Մեկնաբանություն',
            filesLabel: 'Կցված ֆայլեր',
            submissionLabel: 'Ուղարկել մեկնաբանություն',
          },
          hazards: {
            back: 'Վերադառնալ',
            hazards: 'Ապահովության միջոցներ',
            next: 'Հաջորդ',
            no: 'Ոչ',
            noTasksForHazard: 'Այս վտանգի համար կատարելիք առաջադրանքներ չկան։',
            yes: 'Այո',
          },
          induction: {
            continue: 'Շարունակել',
            induction: 'Ներածություն',
          },
          index: {
            checkIn: 'Գրանցվել',
            description: 'Խնդրում ենք լրացնել ընտրված աշխատանքի ռիսկերի գնահատումը։',
            fail: 'Աշխատանքային կարգի ստուգման գործընթացը ձախողվեց։',
            haltMessage:
              'Նկարագրված են պոտենցիալ ռիսկեր։ Խնդրում ենք կանգնեցնել աշխատանքը, վերանայել անվտանգության ուղեցույցները և կապվել ձեր ղեկավարի հետ՝ լրացուցիչ հրահանգների համար։',
            header: 'Աշխատանքային կարգի ստուգումներ',
            endVisit: 'Ավարտել այցը',
            leaveFeedback: 'Թողնել մեկնաբանություն',
          },
          safeToProceed: {
            continue: 'Շարունակել',
            safeToProceed: 'Անվտանգ է շարունակելու համար',
          },
        },
      },
    },
    index: {
      title: 'Բարի գալուստ',
      description: 'Սկսելու համար սկանեք ձեր գտնվելու վայրի QR կոդը։',
    },
    login: {
      errorTitle: 'Անսպասելի սխալ',
      errorMessage:
        'Անսպասելի սխալ է տեղի ունեցել։ Խնդրում ենք փորձել կրկին QR կոդը սկանելուց հետո։',
    },
    unauthenticated: {
      welcome: {
        title: 'Բարի գալուստ {site}',
        description:
          'Մինչ մենք կարողանանք ձեզ ցույց տալ աշխատանքային կարգեր, մենք պետք է ստուգենք ձեր տվյալները։ Շարունակելու համար սեղմեք ստորև գտնվող կոճակը։',
        next: 'Շարունակել',
      },
      index: {
        errorTitle: 'Անսպասելի սխալ',
        errorMessage:
          'Անսպասելի սխալ է տեղի ունեցել։ Խնդրում ենք փորձել կրկին QR կոդը սկանելուց հետո։',
      },
      contractor: {
        title: 'Ով է ձեր գործատուն',
        contractor: 'Գործատու',
        contractorLabel: 'Սկսեք մուտքագրել ձեր ընկերության անունը',
        contractorHint: 'Դուք պետք է մուտքագրեք 3 կամ ավելի նշան, որպեսզի տեսնեք արդյունքները',
        defaultSelectPlaceholder: '--Խնդրում ենք ընտրել--',
        next: 'Հաջորդ',
      },
      user: {
        title: 'Ով եք դուք',
        cancel: 'Չեղարկել',
        createNewUserLabel: 'Իմ անունը ցուցակում չէ',
        existingUserLabel: 'Սկսեք մուտքագրել ձեր անունը',
        existingUserHint: 'Դուք պետք է մուտքագրեք 3 կամ ավելի նշան, որպեսզի տեսնեք արդյունքները',
        newUserLabel: 'Մուտքագրեք ձեր ամբողջական անունը',
        next: 'Հաջորդ',
        user: 'Օգտվող',
      },
      verification: {
        methods: {
          add: {
            add: 'Ավելացնել ստուգման մեթոդ',
            defaultSelectPlaceholder: '--Խնդրում ենք ընտրել--',
            emailLabel: 'Էլ. հասցե',
            existingMethodWarning:
              'Դուք արդեն ունեք այս ստուգման մեթոդի համար սպասվող հարցում, որը սպասում է ադմինիստրատորի հաստատմանը։ Նոր մուտքագրումը կփոխարինի դրան։',
            method: 'Մեթոդ',
            methodLabel: 'Մեթոդ',
            mobileCountryHint: 'Խնդրում ենք ընտրել ձեր երկրի կոդը',
            mobileCountryLabel: 'Մոբիլ երկրի կոդ',
            mobileHint: 'Խնդրում ենք մուտքագրել ձեր մոբիլ հեռախոսի համարը',
            mobileLabel: 'Մոբիլ',
            title: 'Ավելացնել ստուգման մեթոդ',
          },
          confirm: {
            confirm: 'Հաստատել',
            description: 'Խնդրում ենք հաստատել ձեր ստուգման մեթոդը շարունակելու համար։',
            label: 'Մուտքագրեք ձեր կոդը',
            resend: 'Վերագրվել',
            resendPrompt: 'Չե՞ք ստացել կոդը',
            title: 'Հաստատել ստուգման մեթոդը',
          },
          confirmed: {
            description:
              'Դուք կտեղեկացվեք, երբ այս ստուգման մեթոդը հաստատվի ձեր ադմինիստրատորի կողմից, և այնուհետև կարող եք սկսել այն օգտագործել ձեր ինքնությունը ստուգելու համար։',
            forceApproval:
              'Մինչև այն հաստատվի, դուք չեք կարողանա մուտք գործել աշխատանքային կարգեր։',
            nonForceApproval:
              'Այս ընթացքում դուք կարող եք շարունակել մուտք գործել աշխատանքային կարգեր սահմանափակ մուտքով։',
            nonForceApprovalButtonLabel: 'Շարունակել սահմանափակ մուտքով',
            title: 'Սպասում է հաստատմանը',
          },
          addNew: 'Ավելացնել նոր ստուգման մեթոդ',
          description:
            'Մենք պետք է ստուգենք ձեր ինքնությունը, որպեսզի ձեզ լիարժեք մուտք տրամադրենք աշխատանքային կարգին։',
          email: 'Էլ. հասցե',
          hint: 'Մենք կուղարկենք հղում ձեր ընտրված ստուգման մեթոդին, որը կտա ձեզ լիարժեք մուտք աշխատանքային կարգին։ Եթե դուք պետք է փոխեք որևէ առկա ստուգման մեթոդ, խնդրում ենք կապվել ձեր ադմինիստրատորի հետ։',
          label: 'Ընտրեք ստուգման մեթոդ',
          next: 'Հաջորդ',
          pendingHint: 'Սպասում է ձեր ադմինիստրատորի հաստատմանը',
          sms: 'SMS',
          title: 'Ստուգում',
        },
        optional: {
          hint: 'Ձեր օգտվողի տվյալների ստուգումը կտա ձեզ լիարժեք մուտք աշխատանքային կարգին',
          label: 'Ցանկանում եք արդյոք ստուգել ձեր օգտվողի տվյալները',
          next: 'Հաջորդ',
          no: 'Ոչ',
          noHint:
            'Ես չեմ ուզում ստուգել իմ օգտվողի տվյալները և շարունակել աշխատանքային կարգին սահմանափակ մուտքով',
          title: 'Ստուգում',
          yes: 'Այո',
          yesHint:
            'Ես ուզում եմ ստուգել իմ օգտվողի տվյալները և ստանալ լիարժեք մուտք աշխատանքային կարգին',
        },
        sent: {
          description:
            'Մուտքի հղումը ուղարկվել է {identifier}։ Խնդրում ենք սեղմել հղմանը՝ ձեր մուտքը ավարտելու համար։',
          title: 'Մուտքի հղումը ուղարկվել է',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Երեկ',
      today: 'Այսօր',
      days: {
        monday: 'Երկուշաբթի',
        tuesday: 'Երեքշաբթի',
        wednesday: 'Չորեքշաբթի',
        thursday: 'Հինգշաբթի',
        friday: 'Ուրբաթ',
        saturday: 'Շաբաթ',
        sunday: 'Կիրակի',
      },
      months: {
        january: 'Հունվար',
        february: 'Փետրվար',
        march: 'Մարտ',
        april: 'Ապրիլ',
        may: 'Մայիս',
        june: 'Հունիս',
        july: 'Հուլիս',
        august: 'Օգոստոս',
        september: 'Սեպտեմբեր',
        october: 'Հոկտեմբեր',
        november: 'Նոյեմբեր',
        december: 'Դեկտեմբեր',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Ինչ-որ բան սխալ է gegaan',
      message: 'Խնդրում ենք փորձել կրկին QR կոդը սկանելուց հետո։',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Անհայտ օգտվող',
      },
      none: 'Ոչ մեկը',
      types: {
        stateTransition: 'Կարգավիճակի փոփոխություն',
        contractorAssigned: 'Գործատու նշանակված',
        engineerAssigned: 'Ինժեներ նշանակված',
        serviceAssigned: 'Ծառայություն նշանակված',
        priorityChanged: 'Prioriteti փոփոխված',
        actionableDateChanged: 'Գործողության ամսաթիվը փոփոխված',
        dueDateChanged: 'Վերջնաժամկետը փոփոխված',
        etaDateChanged: 'Հասանելիության ժամանակի փոփոխված',
        spendLimitApproved: 'Ծախսերի սահմանաչափը հաստատված',
        spendLimitCancelled: 'Ծախսերի սահմանաչափի հարցումը չեղարկված',
        spendLimitRejected: 'Ծախսերի սահմանաչափը մերժված',
        spendLimitRequested: 'Ծախսերի սահմանաչափի հարցում',
        jobSheetUploaded: 'Աշխատանքի թերթիկը բեռնված',
        slaAlertSent: 'Ժամանակին արձագանքելու SLA ծանուցում',
        issuedWorkPermit: 'Աշխատանքի թույլտվություն տրված',
        requestForServiceSent: 'Ծառայության խնդրանք ուղարկված',
        comment: 'Մեկնաբանություն ավելացված',
        unknown: 'Անհայտ իրադարձություն',
      },
      labels: {
        actionableDate: 'Գործողության ամսաթիվ',
        comment: 'Մեկնաբանություն',
        file: 'Ֆայլ',
        contractor: 'Գործատու',
        dueDate: 'Վերջնաժամկետ',
        etaDate: 'Հասանելիության ժամանակ',
        engineer: 'Ինժեներ',
        priority: 'Prioriteti',
        requestForService: 'Ծառայության խնդրանք',
        service: 'Ծառայություն',
        spendLimit: 'Ծախսերի սահմանաչափ',
        status: 'Կարգավիճակ',
        workPermit: 'Աշխատանքի թույլտվություն',
      },
    },
  },
}
